import { Link } from "react-router-dom";
import { useLanguage } from "@/contexts/LanguageContext";
import { ChevronRight } from "lucide-react";
import { SEOHead } from "@/components/SEOHead";

const NotFound = () => {
  const { t } = useLanguage();

  return (
    <>
      <SEOHead
        title="404 – Seite nicht gefunden | OnePractix"
        description="Die gesuchte Seite existiert nicht."
        noIndex
      />
      <div className="flex min-h-screen items-center justify-center bg-background px-6">
        <div className="text-center">
          <h1 className="op-gradient-text text-[7rem] md:text-[10rem] font-bold leading-none tracking-[-0.06em]">404</h1>
          <p className="mt-4 text-2xl md:text-3xl font-semibold tracking-[-0.025em] text-foreground">{t("notFound.message")}</p>
          <Link to="/" className="op-chevron-link mt-8 text-lg">
            <span>{t("notFound.backHome")}</span>
            <ChevronRight className="h-5 w-5" strokeWidth={2.5} />
          </Link>
        </div>
      </div>
    </>
  );
};

export default NotFound;
